
/**
 * Replaces a <div> element with an <a> (link) element and removes any surrounding <code> tag if present.
 * Useful for accessibility purposes.
 */
export default {
  methods: {
    transformDivToLink (elemId, href) {
      const elem = document.getElementById(elemId)
      if (!elem) return

      const a = document.createElement('a')
      a.id = elem.id // Keep ID
      a.href = href || '#'
      a.textContent = elem.textContent // Keep text inside

      // Check if the <div> is wrapped in a <code> element
      if (elem.parentNode.tagName === 'CODE') {
        const codeElem = elem.parentNode
        codeElem.parentNode.replaceChild(a, codeElem)
      } else {
        elem.parentNode.replaceChild(a, elem)
      }
    }
  }
}
